import React from "react";
import { Navigate } from "react-router-dom";
import { useAgentAccountDetails } from "shared/hooks/common";
import { DEFAULT_LANDING_PAGES, DEFAULT_DASHBOARD_FALLBACK } from "shared/constants/Constants";

/**
 * Renders when the user visits /dashboard with no segment.
 * Redirects to the role's default dashboard page so the router handles it without relying on AppLayout effect.
 */
export default function DashboardIndexRoute() {
  const { agentRole } = useAgentAccountDetails();
  const defaultPath =
    agentRole && DEFAULT_LANDING_PAGES[agentRole] != null
      ? DEFAULT_LANDING_PAGES[agentRole]
      : DEFAULT_DASHBOARD_FALLBACK;

  if (
    process.env.NODE_ENV !== "production" &&
    agentRole &&
    DEFAULT_LANDING_PAGES[agentRole] == null
  ) {
    console.warn(
      `[DashboardIndexRoute] Role "${agentRole}" is not in DEFAULT_LANDING_PAGES; add an entry in shared/constants/Constants.js. Using fallback: ${DEFAULT_DASHBOARD_FALLBACK}`
    );
  }

  return <Navigate to={`/dashboard/${defaultPath}`} replace />;
}
